const RECAPTCHA_URL = 'https://www.google.com/recaptcha';
const RECAPTCHA_V2_PLACEHOLDER_ID = 'recaptcha-widget-placeholder';

export { RECAPTCHA_URL, RECAPTCHA_V2_PLACEHOLDER_ID };
